export const authorizationRequestErrorString = {
    "OIDC_COMPLETE_AUTHORIZATION_REQUEST_METHOD_NOT IMPLEMENTED": "Base class method completeAuthorizationRequest not implemented intentionally",
    "OIDC_MISMATCHED_STATE_IN_REQUEST_AND_RESPONSE": "Mismatched request (state in webview response and request state dont match)",
    "OIDC_SETUP_CODE_VERIFIER_ERROR": "Failed to setup code verifier and add code challenge to authorization request"
};